import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@predoc/cow';

interface TruncatedCellProps {
  text: string;
  className?: string;
}

export const TruncatedCell = ({ text, className }: TruncatedCellProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('block max-w-[320px] truncate', className)}>
          {text}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[480px]">
        {text}
      </TooltipContent>
    </Tooltip>
  );
};
